<template>
  <div id="app" :class="{ on: init }">
    <!-- <div class="music-btn" :class="musicState" @click="toggleMusic()"></div> -->
    <transition :name="transitionName">
      <router-view class="view app-view"></router-view>
    </transition>
    <div class="verticalScreen" v-show="verticalScreen">
      <div class="logo">
        <img src="@/assets/images/m-logo.jpg" alt="" />
      </div>
      <div class="img">
        <img src="@/assets/images/vertical-screen-text.png" alt="" />
      </div>
      <div class="main" @click="mainRou()">
        <img src="@/assets/images/main-button.png" alt="" />
      </div>
      <div style="position: fixed; bottom: 10px; left: 0; width: 100%; z-index: 999">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style="text-align: center; display: block">
          <img
            style="width: 30%"
            :class="{ ipad: !isMobole }"
            src="https://fnws-oss.oss.fnws.top/img/fillings.png"
            alt=""
            srcset=""
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { wxConfig } from '@/services/wx';
import { utilsService } from './services/utils.service';

export default {
  name: 'app',
  data() {
    return {
      init: false,
      transitionName: 'fade',
      music: {},
      musicState: '',
      verticalScreen: false,
      isMobole: false,
    };
  },
  components: {},
  methods: {
    // toggleMusic() {
    //   this.musicState ? this.music.pause() : this.music.play();
    // },
    mainRou() {
      if (window.location.host === 'test.fnws.top') {
        window.location.replace('https://test.fnws.top/Porsche-Productandservice/');
      } else {
        window.location.replace(
          'https://aftersales.porsche-cloud.com/productandservice/?utm_source=windowfilm&utm_medium=allinone',
        );
      }
    },
    renderResize() {
      // 判断横竖屏
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (width < height) {
        this.verticalScreen = true;
      } else {
        this.verticalScreen = false;
      }
    },
  },
  created() {
    if (/Android|iPhone/i.test(navigator.userAgent)) {
      this.$store.commit('setMobile', true);
      this.isMobole = true;
    }
    setTimeout(() => {
      this.init = true;
    }, 200);
  },
  mounted() {
    wxConfig();
    this.renderResize();
    // 判断是不是手机
    window.addEventListener('resize', this.renderResize, false);
  },

  watch: {},
};
</script>

<style lang="scss">
.verticalScreen {
  width: 100vw;
  height: 100vh;
  background: #000;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  flex-direction: column;
  background: url('assets/images/vertical-plate.jpg') no-repeat center / cover;
  // background-size: 100%;
  .ipad {
    width: 23% !important;
  }
  .main {
    position: fixed;
    top: 0.5vw;
    left: 0;
    // width: 12.5vw;
    z-index: 10;
  }
  .logo {
    img {
      width: 100%;
    }
  }

  .img {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 40px;
    font-size: 12px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 220px;
    }
  }

  img {
    width: 50%;
  }
  .text {
    font-size: 20px;
    color: #fff;
  }
}

.fade-leave-active,
.fade-enter-active {
  transition: 0.3s linear;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

body {
  background: #000;
}
#app {
  opacity: 0;
  pointer-events: none;

  > .view {
    width: 100%;
  }
  &.on {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>
